import styled from 'styled-components';

const StyledCheckboxWrapper = styled.div`
  > div {
     display: flex;
 
     :not(:first-of-type) {
       margin-top: 0.8rem;
     }

     label {
       min-width: 4rem;

       i {
         @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
           top: 0.2em;
         }
       }
     }

    > div {
      white-space: nowrap;
      margin-right: 1rem;
      display: block;

      :last-of-type {
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }
`;

export {
  StyledCheckboxWrapper,
};